import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FinanceInvoiceDivComponent} from './finance-invoice-div.component';
import {ClickOutsideModule} from 'ng-click-outside';
import {FormListGeneratorModule} from '../form-list-generator/form-list-generator.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';



@NgModule({
  declarations: [
    FinanceInvoiceDivComponent
  ],
  exports: [
    FinanceInvoiceDivComponent
  ],
    imports: [
        CommonModule,
        ClickOutsideModule,
        FormListGeneratorModule,
        MatProgressSpinnerModule
    ]
})
export class FinanceInvoiceDivModule { }
